import web3Service from '../web3.service';
import { NetworkId } from '../../types/network.types';
import { AbiItem } from 'web3-utils';

export default {
  balanceOf: async function (
    networkId: NetworkId,
    tokenAbi: AbiItem[],
    tokenAddress: string,
    accountAddress: string,
  ) {
    return await new (web3Service.getInstanceByNetworkId(networkId).eth.Contract)(
      tokenAbi,
      tokenAddress,
    ).methods
      .balanceOf(accountAddress)
      .call();
  },
};
